module.exports = __webpack_public_path__ + "KaTeX_Main-BoldItalic.3d4ad87a.woff";